import {
    ADD_THUMBNAIL_LINK,
    FETCH_FILE_FOR_THUMBNAIL_START,
    FETCH_FILE_FOR_THUMBNAIL_SUCCESS,
    FETCH_FILE_FOR_THUMBNAIL_ERROR,
    CLEAR_THUMBNAIL_LINKS
  } from './constants'
  
  import { createReducer } from 'helpers/ReducerUtil'
  import { combineReducers } from 'redux'
  import _ from 'lodash'
  
  const links = createReducer([], {
    [CLEAR_THUMBNAIL_LINKS]: () => [],
    [ADD_THUMBNAIL_LINK]: (prev, {info, url}) => {
      const { thumbnailId } = info
      for (let i = 0; i < prev.length; i++){
        if (prev[i].thumbnailId === thumbnailId){
          prev[i].url = url
          return prev
        }
      }
      let [nvq, nonNvq] = [[], []]
      prev.concat({...info, url})
        .forEach(x => (x.fileType === 'NVQual System Topology' ? nvq : nonNvq).push(x))
      return [nvq, nonNvq].map((x) => _.orderBy(x, ['fileId'],['desc'])).flat()
    },
  })
  
  const loading = createReducer(false, {
    [FETCH_FILE_FOR_THUMBNAIL_START]: () => true,
    [FETCH_FILE_FOR_THUMBNAIL_SUCCESS]: () => false,
    [FETCH_FILE_FOR_THUMBNAIL_ERROR]: () => false,
  })
  
  export default combineReducers({
    links,
    loading
  })
  